var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{on:{"click":function($event){return _vm.del()}}},[_c('i',{staticClass:"fas fa-trash",attrs:{"title":"Löschen"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }